export default __webpack_public_path__ + "static/media/c-sharp.2e25e98a.svg";